import Vue from 'vue';

import Checkbox from '@/global-components/Checkbox.vue';
import Modal from '@/global-components/Modal.vue';

Vue.component('AppCheckbox', Checkbox);
Vue.component('AppModal', Modal);
